module.exports = __webpack_public_path__ + "static/media/cq_ordine_tempo2.0c28f907.svg";